<template>
    <div></div>
</template>

<script>
export default {
    name: "Home",
    data() {
        return {};
    },
    mounted() {
        let status = this.isMobile();
        // 判断发布域名对象
        if (this.$configs_obj == "bolivia-mi") {
            window.open(`${this.$HomeUrl}/bolivia_mi`, "_self");
        } else if (this.$configs_obj == "chile-infinix") {
            window.open(`${this.$HomeUrl}/chile_infinix`, "_self");
        } else if (this.$configs_obj == "chile-tecno") {
            window.open(`${this.$HomeUrl}/chile_tecno`, "_self");
        } else if (this.$configs_obj == "meizu") {
            window.open(`${this.$HomeUrl}/meizu`, "_self");
        } else if (this.$configs_obj == "realme") {
            // window.open(`${this.$HomeUrl}/realme`, "_self");
            let url = status == null ? "/realme" : "/realme_m";
            window.open(`${this.$HomeUrl}${url}`, "_self");
        } else if (this.$configs_obj == "starcell") {
            // window.open(`${this.$HomeUrl}/starcell`, "_self");
            let url = status == null ? "/starcell" : "/starcell_m";
            window.open(`${this.$HomeUrl}${url}`, "_self");
        }
        
        // 验证移动端或pc端 自动跳转
        // if (this.$configs_obj == "bolivia-mi") {
        //     let url = status == null ? "/bolivia_mi" : "/bolivia_mi_m";
        //     window.open(`${this.$HomeUrl}${url}`, "_self");
        // } else if (this.$configs_obj == "chile-infinix") {
        //     let url = status == null ? "/chile_infinix" : "/chile_infinix_m";
        //     window.open(`${this.$HomeUrl}${url}`, "_self");
        // } else if (this.$configs_obj == "chile-tecno") {
        //     let url = status == null ? "/chile_tecno" : "/chile_tecno_m";
        //     window.open(`${this.$HomeUrl}${url}`, "_self");
        // } else if (this.$configs_obj == "nigeria-mi") {
        //     let url = status == null ? "/nigeria_mi" : "/nigeria_mi_m";
        //     window.open(`${this.$HomeUrl}${url}`, "_self");
        // } else if (this.$configs_obj == "realme") {
        //     let url = status == null ? "/realme" : "/realme_m";
        //     window.open(`${this.$HomeUrl}${url}`, "_self");
        // }
        // else if (this.$configs_obj == "starcell") {
        //     let url = status == null ? "/starcell" : "/starcell_m";
        //     window.open(`${this.$HomeUrl}${url}`, "_self");
        // }
    },
    methods: {
        isMobile() {
            let flag = navigator.userAgent.match(
                /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
            );
            console.log(flag);
            return flag;
        },
    },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/Home.vue